exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swal2-container[data-v-16293fc1]{\n    z-index: 2100 !important;\n}\n", ""]);

// exports
